import React from 'react';
import { Button } from '../components/ui/button';
import { Check, Sparkles } from 'lucide-react';
import { programsData } from '../mock/programsData';

const colorTheme = [
  { ring: 'border-pink-300', bg: 'from-pink-50 to-white', accent: 'text-pink-600', btn: 'from-pink-300 to-pink-400 hover:from-pink-400 hover:to-pink-500 text-pink-900', check: 'text-pink-600' },
  { ring: 'border-purple-300', bg: 'from-purple-50 to-white', accent: 'text-purple-600', btn: 'from-purple-300 to-purple-400 hover:from-purple-400 hover:to-purple-500 text-purple-900', check: 'text-purple-600' },
  { ring: 'border-yellow-400', bg: 'from-yellow-50 to-pink-50', accent: 'text-yellow-700', btn: 'from-yellow-300 to-pink-300 hover:from-yellow-400 hover:to-pink-400 text-yellow-900', check: 'text-yellow-700' },
  { ring: 'border-blue-300', bg: 'from-blue-50 to-white', accent: 'text-blue-600', btn: 'from-blue-300 to-blue-400 hover:from-blue-400 hover:to-blue-500 text-blue-900', check: 'text-blue-600' },
  { ring: 'border-green-300', bg: 'from-green-50 to-white', accent: 'text-green-700', btn: 'from-green-300 to-green-400 hover:from-green-400 hover:to-green-500 text-green-900', check: 'text-green-700' }
];

const Programs = () => {
  const handleSelect = (price) => {
    window.open(
      `https://www.paypal.com/paypalme/HolaSpanglish/${price}USD`,
      '_blank',
      'noopener,noreferrer'
    );
  };

  return (
    <section
      id="programs"
      data-testid="programs-section"
      className="py-20 bg-gradient-to-br from-yellow-50 via-pink-50 to-purple-50"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-14">
          <h2 className="text-4xl md:text-5xl font-bold text-purple-600 mb-4">
            {programsData.title}
          </h2>
          <p className="text-base md:text-lg text-purple-600 max-w-2xl mx-auto">
            {programsData.subtitle}
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-7">
          {programsData.plans.map((plan, idx) => {
            const c = colorTheme[idx % colorTheme.length];
            return (
              <div
                key={plan.id}
                data-testid={`program-card-${plan.id}`}
                className={`relative flex flex-col bg-gradient-to-br ${c.bg} border-4 ${c.ring} rounded-3xl p-7 shadow-lg hover:shadow-2xl hover:-translate-y-1 transition-all duration-300 ${plan.featured ? 'lg:scale-105 lg:z-10' : ''}`}
              >
                {plan.featured && (
                  <div className="absolute -top-4 left-1/2 -translate-x-1/2">
                    <div className="bg-gradient-to-r from-yellow-300 to-pink-300 text-yellow-900 px-5 py-1.5 rounded-full text-xs font-bold border-3 border-yellow-500 shadow-lg flex items-center gap-1.5">
                      <Sparkles className="h-3.5 w-3.5" />
                      Most Popular
                    </div>
                  </div>
                )}

                <div className="text-center pt-2 pb-5 border-b-2 border-purple-100">
                  <h3 className={`text-2xl font-extrabold tracking-wide ${c.accent} mb-1`}>
                    {plan.name}
                  </h3>
                  <p className="text-sm italic text-purple-700 mb-3">
                    "{plan.tagline}"
                  </p>
                  <div className="flex items-baseline justify-center gap-1">
                    <span className={`text-4xl font-bold ${c.accent}`}>
                      ${plan.price}
                    </span>
                    <span className="text-gray-600 text-sm">{plan.currency}</span>
                  </div>
                  <p className="text-xs text-gray-500 mt-1">{plan.validity}</p>
                </div>

                <p className="text-sm text-gray-700 mt-4 mb-4 leading-relaxed">
                  {plan.description}
                </p>

                <ul className="space-y-2.5 mb-6 flex-1">
                  {plan.features.map((f, i) => (
                    <li key={i} className="flex items-start gap-2.5 text-sm text-gray-700">
                      <Check className={`h-4 w-4 ${c.check} flex-shrink-0 mt-0.5`} />
                      <span>{f}</span>
                    </li>
                  ))}
                </ul>

                <Button
                  data-testid={`program-cta-${plan.id}`}
                  onClick={() => handleSelect(plan.price)}
                  className={`w-full py-5 font-bold text-base rounded-full border-3 ${c.ring} bg-gradient-to-r ${c.btn} transition-all duration-300 hover:shadow-xl hover:scale-105`}
                >
                  {plan.cta}
                </Button>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Programs;
